import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getClosestCardHeader } from '@lib/popups';
import { getTimelineSummarySelector } from './@arch/selectors';
import React from 'react';
import { DateRangePicker } from '@ui/DateRangePicker';
import { useCurrentCustomer, useSonarSelector } from '@hooks';
export const TimelineDatePicker = ({ endDate, onChange, startDate }) => {
    const { id, timelineRetentionPeriod } = useCurrentCustomer();
    const isRequested = useSonarSelector(getTimelineSummarySelector.isRequested);
    return (React.createElement("div", { className: 'timeline-date-picker' },
        COPY_SPECIFIC.CHANGES_FROM,
        React.createElement(DateRangePicker, { disabled: isRequested, endDate: endDate, getPopupContainer: getClosestCardHeader, historyLimit: timelineRetentionPeriod, loading: !id, onChange: onChange, startDate: startDate })));
};
